/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Hint_Href1Inputs */

const vi_sitesettings_hint_href1 = /** @type {(inputs: Sitesettings_Hint_Href1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đường dẫn trong website bắt đầu bằng / (vd /tra-cuu-don) hoặc link https://…; để trống nếu không bấm được.`)
};

/**

* @param {Sitesettings_Hint_Href1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_hint_href1 = /** @type {((inputs?: Sitesettings_Hint_Href1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Hint_Href1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_hint_href1(inputs)
});
export { sitesettings_hint_href1 as "siteSettings_hint_href" }